import m from 'mithril';

/**
 * Text component attrs matching the old active typography scale.
 */
export interface TypeAttrs extends m.Attributes {
  /** Semantic text size. */
  size?: 'title' | 'subtitle' | 'heading' | 'subheading' | 'subtext' | 'paragraph';
  /** Render inline. */
  inline?: boolean;
  /** Render with link styling. */
  link?: boolean;
  /** Additional CSS class names. */
  className?: string;
}

const elementForSize = (size: NonNullable<TypeAttrs['size']>): string => {
  switch (size) {
  case 'title':
    return 'h1';
  case 'subtitle':
    return 'h2';
  case 'heading':
    return 'h3';
  case 'subheading':
    return 'h4';
  default:
    return 'p';
  }
};

/**
 * Renders MeshOS typography with semantic element choices.
 */
export const Type: m.Component<TypeAttrs> = {
  view: ({ attrs, children }) => {
    const size = attrs.size ?? 'paragraph';
    const classes = [
      'type',
      `type--${size}`,
      attrs.inline ? 'type--inline' : '',
      attrs.link ? 'type--link' : '',
      attrs.className ?? '',
    ].filter(Boolean).join(' ');

    return m(elementForSize(size), { class: classes }, children);
  },
};
